
import React from 'react';
import ServiceCard from './ServiceCard';

const ServiceSecThree = ({ className }) => {

  return (
    <section className={className} id="service-sec">
        <div
            className="shape-mockup bg-gradient-shape1"
            data-top="15%"
            data-left={0}
        />
        <div className="container">
            <div className="row gy-4 justify-content-center">
                <ServiceCard className="col-lg-4 col-md-6" limit={9} />
            </div>
        </div>
    </section>
  );
};

export default ServiceSecThree;